<template>
  <div class="page-activity" :class="{'mobile': _isMobile}">
    <div class="actipage-activity-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="5"></cmpBanner>

      <div class="g-wrap">
        <div class="g-content">
          <!-- <div class="m-banner-top">
            <div class="top-box">
              <div class="label-box">
                <h1 class="tc mb-20">{{detailData.title}}</h1>
                <p class="price"><span><i>¥ </i>{{detailData.price}}</span></p>
                <p class="txt"><label>规格：</label>{{detailData.ext1}}</p>
                <p class="txt"><label>类别：</label>{{detailData.ext3}}</p>
              </div>

              <div class="pic-box" v-if="detailData.attId">
                <img v-lazy="detailData.attId">
              </div>
            </div>
          </div> -->

          <div class="m-banner-top">
            <div class="top-box">
              <div class="pic-box" v-if="detailData.picture">
                <img v-lazy="detailData.picture">
              </div>

              <div class="label-box m-font-4">
                <h1 class="tc m-font-1 mb-40">{{detailData.name}}</h1>
                <p class="txt">
                  <label>活动时间: </label>
                  <span>{{detailData.publishTime}}</span>
                </p>
                <p class="txt">
                  <label>活动地点: </label>
                  <span>{{detailData.position}}</span>
                </p>
                <p class="txt">
                  <label>活动状态: </label>
                  <span class="status">{{detailData.status==2?'进行中':'已结束'}}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="con">
            <h1 class="g-title-2 mb-30">活动详情</h1>
            <cmpDetail :detailData="detailData" :hideName="true"></cmpDetail>
            <!-- <div class="g-detail-html trans">
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorum qui, quidem numquam modi eveniet debitis id nulla expedita architecto accusamus ipsam iusto doloribus sit autem, repellendus dolor recusandae. Perspiciatis, libero?</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/activity/detail.scss'
export default {
  data() {
    return {
      pageType: this.$route.query.pageType,
      detailData: {
        content: ''
      },
      detailId: this.$route.query.id,
    }
  },
  methods: {
    getDetailData() {
      this.dataList = []

      this.listLoading = true
      this.$http
        .get('/webapi/education/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.data
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    setBread() {
      console.log('00', this.pageType)
      switch(this.pageType) {
        case '1':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '社教活动',
              href: '/activity?pageType=1'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '2':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '游学活动',
              href: '/activity?pageType=2'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '3':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '讲座',
              href: '/activity?pageType=3'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '4':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '手工',
              href: '/activity?pageType=4'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '5':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '其他',
              href: '/activity?pageType=5'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
      }
    }
  },
  created() {
    this.setBread()
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.activity-wrap {
  .g-detail-html {
    width: 100%;
  }
}
</style>


